// fetchMeReferral.js
'use strict';
import fetch from '../resource/customFetch.js';

import getMeData from '../selector/getMeData.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  MERGE_ME_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';
import getNetworkingData from '../selector/getNetworkingData.js';

/**
 * Fetch me referral
 * @kind action
 * @return {Promise} Action promise.
 */
const fetchMeReferral = () => async (dispatch, getState) => {
  const token = getMeData(getState(), 'token');

  const userId = getMeData(getState(), 'id');
  const selectPath = ['me', 'referral', userId];

  const isFetching = getNetworkingData(getState(), selectPath, 'isFetching');
  if (isFetching) {
    return dispatch({ type: '' });
  }

  const fetchOptions = {
    method: 'GET',
    headers: {
      ...getHeaders(),
      ...(token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : {}),
    },
  };

  const url = getResourceUrl({ endpoint: '/me/referral' });

  dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
  try {
    let response = await fetch(url.href, fetchOptions);

    // For 403 response, it returns registration time, referral diamond amount and payment status, so we need to handle 403 case here
    if (!response.ok && response.status !== 403) {
      response = await handleFetchError({
        response,
        dispatch,
        getState,
        fetchOptions,
        fetchUrl: url,
      });
    }

    const result = await response.json();

    dispatch({
      type: MERGE_ME_DATA,
      payload: { referral: { ...result, isEligible: !!response.ok } },
    });

    return dispatch({ type: SET_NETWORKING_SUCCESS, payload: { selectPath } });
  } catch (error) {
    return dispatch({
      type: SET_NETWORKING_ERROR,
      payload: { selectPath, error },
    });
  }
};

export default fetchMeReferral;
